import { Directive, WritableSignal, input, signal } from '@angular/core';
import {
  IUiControlSettings,
  IconType,
  UTILS,
  IUiIconControlSettings,
  UiIconControlSettings,
} from '@aksia/infrastructure';
import { UiControlDirective } from './ui-control.directive';

@Directive({
  selector: 'uicontrol',
  standalone: true,
})
export class UiIconControlDirective extends UiControlDirective {
  //#region Inputs/Outputs

  override settings = input<UiIconControlSettings, IUiIconControlSettings>(
    new UiIconControlSettings(),
    {
      transform: (settings: IUiIconControlSettings) =>
        this.initSettings(settings),
    },
  );

  //#endregion

  //#region Properties

  icon: WritableSignal<IconType | undefined> = signal<IconType | undefined>(
    undefined,
  );
  iconSize: WritableSignal<string | undefined> = signal<string | undefined>(
    undefined,
  );
  iconOnly: WritableSignal<boolean | undefined> = signal<boolean | undefined>(
    undefined,
  );
  iconColor: WritableSignal<string | undefined> = signal<string | undefined>(
    undefined,
  );
  iconCssClass: WritableSignal<string | undefined> = signal<string | undefined>(
    undefined,
  );

  //#endregion

  //#region Functions

  protected override initSettings(
    settings: IUiControlSettings,
  ): IUiControlSettings {
    let iconControlSettings = UTILS.OBJECT.assign(
      new UiIconControlSettings(),
      settings,
    );
    super.initSettings(iconControlSettings);
    this.icon.set(iconControlSettings.icon);
    this.iconSize.set(iconControlSettings.iconSize);
    this.iconOnly.set(iconControlSettings.iconOnly);
    this.iconColor.set(iconControlSettings.iconColor);
    this.iconCssClass.set(iconControlSettings.iconCssClass);
    return iconControlSettings;
  }

  //#endregion
}
